export enum LastPortal {
  Management = 'management',
  Admin = 'admin',
  Taster = 'taster'
}
